export const MAX_DISPLAY_TRANSPORT_ACCESSIBILITY_ONBOARDING_COUNT = 3;
export const TRANSPORT_ACCESSIBILITY_ONBOARDING_COOKIE_KEY = 'transport-accessibility_onboarding_counter';
